<!-- start: ordered addons -->
<div
  *ngIf="products.length > 0"
  class="flex flex-col p-2 -mx-4 border rounded-md border-primary md:mx-0"
>
  <div class="mb-4 text-2xl font-semibold">Add-ons:</div>
  <table class="w-full overflow-x-scroll">
    <thead>
      <tr class="text-[#c4c4c4] text-xs md:text-base border-b">
        <th class="text-start p-2 text-sm font-normal">PRODUCT</th>
        <th class="text-start p-2 text-sm font-normal">NAME</th>
        <th class="text-start p-2 text-sm font-normal">PRICE</th>
        <th class="text-start p-2 text-sm font-normal">TAX(%)</th>
        <th class="text-center p-2 pr-0 text-sm font-normal md:pr-4">
          QUANTITY
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let product of products; let i = index; trackBy: trackByFn"
        class="hover:border-primary hover:border-b hover:bg-matprimary-50"
      >
        <td
          *ngIf="product.EventProductMedia[0]?.MediaFile?.location"
          class="py-1 md:py-2 font-medium"
        >
          <img
            [src]="product.EventProductMedia[0].MediaFile?.location"
            class="ml-1 rounded-md border w-16 h-16"
          />
          <div
            *ngIf="
              orderStateManager.getQuantityAvailableForItem(
                product.eventProductId
              ) <= 20 &&
              orderStateManager.getQuantitySelectedForItem(
                product.eventProductId
              ) >= 0
            "
            class="text-2xs pt-1 pl-1 text-yellow-500"
          >
            <span @fadeInUp>{{
              orderStateManager.getMaxSelectableForItem(product.eventProductId)
            }}</span>
            Remaining
          </div>
        </td>
        <!-- IF NO IMAGE DONT SHOW ANY DEFAULT IMAGE -->
        <td
          *ngIf="!product.EventProductMedia[0]?.MediaFile?.location"
          class="h-14 w-14 md:h-20 md:w-20"
        ></td>
        <td class="text-xs lg:text-base font-medium">
          {{ product.name }}
        </td>
        <td class="text-sm text-center md:text-start lg:text-base font-medium">
          {{ product.price }}
        </td>
        <td
          class="text-sm text-center md:text-start md:pl-4 lg:text-base font-medium"
        >
          {{ product.tax }}
        </td>
        <td
          *ngIf="
            orderStateManager.getMaxSelectableForItem(product.eventProductId) +
              orderStateManager.getQuantitySelectedForItem(
                product.eventProductId
              ) ===
            0
          "
          @fadeInUp
          class="text-sm lg:text-base font-medium text-center"
        >
          <div class="pl-1 pt-1 text-danger">SOLD OUT</div>
        </td>
        <td
          *ngIf="
            orderStateManager.getMaxSelectableForItem(product.eventProductId) +
              orderStateManager.getQuantitySelectedForItem(
                product.eventProductId
              ) >
            0
          "
          class="text-sm lg:text-base font-medium text-center"
        >
          <button
            (click)="itemDecrementClick(product.eventProductId)"
            [disabled]="
              !orderStateManager.canDecrementQuantity(product.eventProductId)
            "
            class="text-lg text-[#c4c4c4] p-0 m-0"
          >
            <!-- [disabled]="product.quantityRemaining === 0" -->
            -
          </button>

          <span class="px-2 mx-2 md:px-3 md:mx-3 md:w-4 border-x">{{
            orderStateManager.getQuantitySelectedForItem(product.eventProductId)
          }}</span>
          <button
            (click)="itemIncrementClick(product.eventProductId)"
            class="text-lg text-[#c4c4c4] p-0 m-0"
            [disabled]="
              !orderStateManager.canIncrementQuantity(product.eventProductId)
            "
          >
            +
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- end: ordered addons -->
